import { render, staticRenderFns } from "./BookedNotification.vue?vue&type=template&id=61e32af1&scoped=true&"
import script from "./BookedNotification.vue?vue&type=script&lang=js&"
export * from "./BookedNotification.vue?vue&type=script&lang=js&"
import style0 from "./BookedNotification.vue?vue&type=style&index=0&id=61e32af1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e32af1",
  null
  
)

export default component.exports